import { render, staticRenderFns } from "./SchoolLeavingManagement.vue?vue&type=template&id=01d26af2&scoped=true"
import script from "./SchoolLeavingManagement.vue?vue&type=script&lang=js"
export * from "./SchoolLeavingManagement.vue?vue&type=script&lang=js"
import style0 from "./SchoolLeavingManagement.vue?vue&type=style&index=0&id=01d26af2&prod&lang=less&scoped=true"
import style1 from "./SchoolLeavingManagement.vue?vue&type=style&index=1&id=01d26af2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d26af2",
  null
  
)

export default component.exports